import { render, staticRenderFns } from "./RelatorioPdf.vue?vue&type=template&id=12d89ac0&"
import script from "./RelatorioPdf.vue?vue&type=script&lang=js&"
export * from "./RelatorioPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports